import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { arrowChevronRight } from '@ibk/shared-assets';
import { Button } from '../Button';
import { Icon } from '../Icon';
import { ProgressItem } from '../ProgressItem';
import styles from './DomainCards.module.css';
const VISIBLE_CARDS_COUNT = 3;
const DomainCard = ({ card, width, visible, }) => {
    const { id, title, iconName, customIcon, iconContainerClassName, subtitle, value = '--', showProgress, status, route, } = card;
    let cardClassName = `${styles.card} ${styles.cardInactive}`;
    if (visible) {
        cardClassName = `${styles.card} ${styles.visible}`;
    }
    return (_jsxs("div", { className: cardClassName, "data-testid": `domain-card-${id}`, style: { width: width ? `${width}px` : undefined }, children: [_jsxs("div", { className: styles.cardHeader, children: [_jsx("div", { className: `${styles.iconContainer} ${iconContainerClassName}`, children: customIcon ||
                            (iconName && (_jsx(Icon, { name: iconName, className: styles.icon, "data-testid": `domain-card-icon-${id}`, "aria-hidden": 'true' }))) }), _jsxs("div", { className: styles.titleContainer, children: [_jsx("h3", { className: styles.title, "data-testid": `domain-card-title-${id}`, children: title }), _jsx("div", { className: styles.subtitleContainer, children: subtitle && (_jsxs("div", { className: styles.subtitleWithStatus, children: [status && (_jsx("div", { className: `${styles.statusBadge} ${status === 'active' ? styles.statusBadgeActive : styles.statusBadgeInactive}`, "data-testid": `domain-card-status-${id}` })), _jsx("span", { className: styles.subtitle, "data-testid": `domain-card-subtitle-${id}`, children: subtitle })] })) })] })] }), _jsxs("div", { className: styles.cardFooter, children: [_jsx("span", { className: styles.value, "data-testid": `domain-card-value-${id}`, children: value }), showProgress && _jsx(ProgressItem, { size: 16, variant: 'active', "data-testid": `domain-card-progress-${id}` }), route && (_jsx(NavLink, { to: route, children: _jsx("img", { src: arrowChevronRight, alt: `arrow-right-${id}`, "data-testid": `domain-card-arrow-${id}` }) }))] })] }));
};
export default function DomainCards({ cards, 'data-testid': dataTestId, isSliderEnabled = true }) {
    const sliderRef = useRef(null);
    const [sliderWidth, setSliderWidth] = useState(0);
    const [visibleCards, setVisibleCards] = useState([]);
    const [cardWidth, setCardWidth] = useState(0);
    useEffect(() => {
        const visibleCardsList = [];
        for (let i = 0; i <= VISIBLE_CARDS_COUNT; i++) {
            visibleCardsList.push(i);
        }
        setVisibleCards(visibleCardsList);
        const updateWidth = () => {
            if (sliderRef.current) {
                setSliderWidth(sliderRef.current.offsetWidth);
            }
        };
        updateWidth();
        window.addEventListener('resize', updateWidth);
        return () => {
            window.removeEventListener('resize', updateWidth);
        };
    }, []);
    useEffect(() => {
        setSliderWidth(sliderRef.current?.offsetWidth ?? 0);
    }, [cards.length]);
    useEffect(() => {
        if (sliderRef.current) {
            sliderRef.current.scrollLeft = 0;
        }
        let cardWidth = sliderWidth / (VISIBLE_CARDS_COUNT + 0.25);
        if (cardWidth < 250) {
            cardWidth = 250;
        }
        setCardWidth(cardWidth);
        const visibleCardsWidth = VISIBLE_CARDS_COUNT * cardWidth;
        const visibleCardsList = [];
        let realVisibleCardsCount = VISIBLE_CARDS_COUNT;
        if (visibleCardsWidth > sliderWidth) {
            realVisibleCardsCount = Math.floor(sliderWidth / cardWidth);
        }
        for (let i = 0; i <= realVisibleCardsCount; i++) {
            visibleCardsList.push(i);
        }
        setVisibleCards(visibleCardsList);
    }, [sliderWidth]);
    const handlePrevious = () => {
        if (sliderRef.current && visibleCards[0] > 0) {
            sliderRef.current.scrollLeft -= cardWidth;
            setVisibleCards(prev => prev.map(card => card - 1));
        }
    };
    const handleNext = () => {
        if (sliderRef.current && visibleCards[visibleCards.length - 1] < cards.length) {
            console.log('handleNext visibleCards', visibleCards);
            sliderRef.current.scrollLeft += cardWidth;
            setVisibleCards(prev => prev.map(card => card + 1));
        }
    };
    if (!cards.length) {
        return null;
    }
    const sliderClassName = isSliderEnabled ? styles.slider : `${styles.slider} ${styles.sliderDisabled}`;
    return (_jsxs("div", { className: styles.container, "data-testid": dataTestId ?? 'domain-cards', children: [_jsx(Button, { variant: 'tertiary', size: 'small', className: styles.sliderControls, dataTestId: 'domain-cards-slider-previous', leftIcon: 'arrowChevronLeft', onClick: handlePrevious, "aria-label": 'Voltar' }), _jsx("div", { className: sliderClassName, ref: sliderRef, children: cards.map((card, index) => (_jsxs(React.Fragment, { children: [_jsx(DomainCard, { card: card, width: isSliderEnabled ? cardWidth : undefined, visible: visibleCards.includes(index) }), index < cards.length - 1 && (_jsx("div", { className: styles.divider, "data-testid": `domain-cards-divider-${index}` }))] }, card.id))) }), _jsx(Button, { variant: 'tertiary', size: 'small', className: styles.sliderControls, dataTestId: 'domain-cards-slider-next', rightIcon: 'arrowChevronRight', onClick: handleNext, "aria-label": 'Avan\u00E7ar' })] }));
}
